// Offsets for anything that has to sit under the pinned top menu. Navigation pins itself (menu and
// organization strip) on every page. Together the two bars are 98px tall (h-16 menu + h-8 strip +
// two 1px borders), so anything else sticky on a page uses the offsets below (7.25rem = 116px: the
// bars plus an 18px gap) to sit just under them instead of sliding beneath; scrollIntoView targets
// get the same clearance from the html element's scroll-padding-top (index.css). Change the bars'
// height and all of these change with it.
export const PINNED_SIDEBAR_STICKY = "top-[7.25rem] max-h-[calc(100vh-8.25rem)]";
export const PINNED_PANEL_TOP = "top-[7.25rem]";
